<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="24">
          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="searchValue"
          />
          <label class="search-label">客户</label>
          <Select
            v-model="customerId"
            class="search-input"
            clearable
            style="width: 180px"
          >
            <Option
              v-for="item in customerIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <label class="search-label">负责人</label>
          <Select
            v-model="salesUserId"
            class="search-input"
            clearable
            style="width: 180px"
          >
            <Option
              v-for="item in salesUserIds"
              :value="item.id"
              :key="item.id"
              >{{ item.real_name }}</Option
            >
          </Select>
          <label class="search-label">状态</label>
          <Select
            style="width: 100px"
            v-model="status"
            class="search-input"
            clearable
          >
            <Option
              v-for="item in statusList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <label class="search-label">开始时间</label>
          <Date-picker
            :value="startTime"
            @on-change="startTime = $event"
            type="datetime"
            placeholder="选择开始时间"
            style="width: 170px"
          ></Date-picker>
          <label class="search-label">结束时间</label>
          <Date-picker
            :value="endTime"
            @on-change="endTime = $event"
            type="datetime"
            placeholder="选择结束时间"
            style="width: 170px"
          ></Date-picker>
          <Button @click="handleSearch" class="search-btn" type="primary"
            >搜索</Button
          >
        </Col>
      </Row>
      <Row class="search-con">
        <Col class="search-right">
          <Button @click="downloadReport" type="primary" class="search-btn"
            >导出报表</Button
          >
          <Button @click="showAddModal" type="primary" class="search-btn"
            >添加</Button
          >
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
        @on-selection-change="changeId"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            :page-size-opts="pageSizeOpts"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>
    <Modal
      :width="800"
      :mask-closable="false"
      v-model="addFinanceModal"
      title="添加出货单"
      footer-hide
    >
      <finance-forms
        ref="addFinanceChild"
        @on-ok="addFinanceSubmit"
        @on-cancel="cancel"
      />
    </Modal>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="addModal"
      title="添加订单"
      footer-hide
    >
      <forms
        @searchSales="searchSales"
        :resetFlag="resetFlag"
        ref="addChild"
        @on-ok="addSumit"
        @on-cancel="cancel"
      />
    </Modal>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="editModal"
      title="编辑订单"
      footer-hide
    >
      <forms
        @searchSales="searchSales"
        :resetFlag="resetFlag"
        ref="editChild"
        :editData="editData"
        @on-ok="editSumit"
        @on-cancel="cancel"
      />
    </Modal>
    <Modal v-model="editUnitModal" title="修改单价" @on-ok="editUnitSubmit">
      <Row>
        <Col>
          <Input v-model="editUnitData.price" />
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
import Tables from '_c/tables/table-only.vue'
import Forms from './order-form.vue'
import FinanceForms from './finance-form.vue'
import store from '@/store'
import {
  downloadOrderExport,
  getOrderList,
  getOrderInfo,
  addOrder,
  delOrder,
  editOrder,
  updateUserStatus,
  getAllCustomer,
  getAllUser,
  getAllFactory,
  searchSaleUser,
  cancelOrder,
  confirmOrder,
  editUnitPrice
} from '@/api/data'
import { getUserInfo } from '@/api/user'
export default {
  name: 'order',
  components: {
    Tables,
    Forms,
    FinanceForms
  },
  data () {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40, 100, 200, 500, 1000],
      addFinanceModal: false,
      selectId: [],
      pieceCount: 0,
      startTime: '',
      endTime: '',
      modalWidth: 600,
      editUnitModal: false,
      editUnitData: {},
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      customerIds: [],
      searchValue: '',
      customerId: '',
      salesUserIds: [],
      salesUserId: '',
      statusList: [
        { id: 0, name: '初创建' },
        { id: 1, name: '已确认' },
        { id: 2, name: '入库完成' },
        { id: 3, name: '检测中' },
        { id: 4, name: '检测完成' },
        { id: 5, name: '付款完成' },
        { id: 6, name: '已完成' },
        { id: 7, name: '已取消' }
      ],
      status: '',
      tableLoading: true,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '订单编号',
          fixed: 'left',
          key: 'order_no',
          width: 200,
          editable: true
        },
        {
          title: '类型',
          key: 'type',
          width: 100,
          render: (h, params) => {
            let texts = ''
            if (params.row.type == 0) {
              texts = '验布类'
            } else if (params.row.type == 1) {
              texts = '包装类'
            }
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          }
        },
        { title: '客户', key: 'customerName', width: 200, editable: true },
        { title: '下单人', key: 'downOrderUser', width: 150, editable: true },
        {
          title: '状态',
          key: 'status',
          width: 100,
          render: (h, params) => {
            let texts = ''
            if (params.row.status == 0) {
              texts = '初创建'
            } else if (params.row.status == 1) {
              texts = '已确认'
            } else if (params.row.status == 2) {
              texts = '入库完成'
            } else if (params.row.status == 3) {
              texts = '检测中'
            } else if (params.row.status == 4) {
              texts = '检测完成'
            } else if (params.row.status == 5) {
              texts = '出货完成'
            } else if (params.row.status == 6) {
              texts = '已完成'
            } else if (params.row.status == 7) {
              texts = '已取消'
            }
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          },
          width: 90,
          editable: true
        },
        { title: '已出货数量', key: 'usedCount', width: 150, editable: true },

        { title: '门店', key: 'factoryName', width: 150, editable: true },
        { title: '负责人', key: 'salesName', width: 100, editable: true },
        {
          title: '预计匹数',
          key: 'expect_piece_count',
          width: 100,
          editable: true
        },
        { title: '总要求码长', key: 'allStandLength', width: 100, editable: true },
        { title: '总测量码长', key: 'allLength', width: 100, editable: true },
        { title: '单价', key: 'one_code_money', width: 80, editable: true },
        { title: '总金额', key: 'money', width: 100, editable: true },
        {
          title: '备注',
          key: 'remarks',
          width: 100,
          render: (h, params) => {
            return h(
              'Tooltip',
              {
                props: { placement: 'top-start' }
              },
              [
                this.maxSlice(params.row.remarks),
                h(
                  'span',
                  {
                    slot: 'content',
                    style: {
                      whiteSpace: 'normal',
                      wordBreak: 'break-all'
                    }
                  },
                  params.row.remarks
                )
              ]
            )
          },
          editable: true
        },
        {
          title: '预计交付时间',
          key: 'arrived_time',
          width: 150,
          editable: true
        },
        { title: '创建时间', key: 'create_time', width: 150, editable: true },
        {
          title: '付款时间',
          key: 'pay_time',
          width: 150,
          editable: true
        },
        {
          title: 'Handle',
          key: 'handle',
          width: 150,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'text',
                    size: 'small',
                    disabled: params.row.type === 1
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      if (params.row.type == 0) {
                        this.viewBatch(params)
                      }
                    }
                  }
                },
                '染缸信息'
              ),
              h(
                'Dropdown',
                {
                  props: {
                    transfer: true
                  }
                },
                [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'text',
                        size: 'small'
                      }
                    },
                    '更多'
                  ),
                  h(
                    'DropdownMenu',
                    {
                      slot: 'list'
                    },
                    [
                      h(
                        'DropdownItem',
                        {
                          nativeOn: {
                            click: (name) => {
                              this.showEditModal(params)
                            }
                          }
                        },
                        '编辑'
                      ),
                      h(
                        'DropdownItem',
                        {
                          nativeOn: {
                            click: (name) => {
                              this.showAddFinanceModal(params)
                            }
                          }
                        },
                        '创建出货单'
                      ),
                      h(
                        'DropdownItem',
                        {
                          nativeOn: {
                            click: (name) => {
                              this.showEditUnitModal(params)
                            }
                          }
                        },
                        '编辑单价'
                      ),
                      h(
                        'DropdownItem',
                        {
                          nativeOn: {
                            click: (name) => {
                              this.cancelOrder(params)
                            }
                          }
                        },
                        '取消订单'
                      ),
                      h(
                        'DropdownItem',
                        {
                          nativeOn: {
                            click: (name) => {
                              this.handleDelete(params)
                            }
                          }
                        },
                        '删除'
                      )
                    ]
                  )
                ]
              )
            ])
          }
        }
      ],
      tableData: []
    }
  },
  methods: {
    changeId (selection) {
      this.selectId = []
      this.pieceCount = selection.length
      for (let i = 0; i < selection.length; i++) {
        this.selectId[i] = selection[i].id
      }
    },
    downloadReport () {
      if (this.selectId.length == 0) {
        this.$Message.warning('请选择布匹')
        return
      }

      downloadOrderExport(this.selectId).then((res) => {
        if (res.data.code == 200) {
          var time = this.pieceCount * 50
          window.setTimeout(function () {
            window.open('https://bu.sinano-ai.com/' + res.data.data)
          }, time)
        }
      })
    },
    showAddFinanceModal (params) {
      this.$refs.addFinanceChild.initData(params)
      this.addFinanceModal = true
    },
    addFinanceSubmit () {
      this.addFinanceModal = false
    },
    checkOrder (params) {
      confirmOrder(params.row.id).then((res) => {
        if (res.data.code == 200) {
          this.$Message.success('成功!')
          this.handleSearch()
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    maxSlice (v) {
      if (v) {
        return v.length > 4 ? v.slice(0, 4) + '...' : v
      }
    },
    isSale () {
      return store.state.user.access.indexOf('sales') != -1
    },
    showAddModal () {
      getAllCustomer().then((res) => {
        var customerList = res.data.data.records
        this.$refs.addChild.setCustomerData(customerList)
        if (!this.isSale()) {
          getAllFactory().then((res) => {
            var factoryList = res.data.data.records
            this.$refs.addChild.setFactoryData(factoryList)
            this.$refs.addChild.setIsSale(false)
            this.addModal = true
            this.resetFlag = !this.resetFlag
          })
        } else {
          getUserInfo().then((res) => {
            if (res.data.code == 200) {
              this.$refs.addChild.setSaleData(res.data.data)
              this.$refs.addChild.setIsSale(true)
              this.addModal = true
            }
          })
        }
      })
      this.$refs.addChild.setIsEdit(false)
    },
    showEditModal (params) {
      getAllCustomer().then((res) => {
        var customerList = res.data.data.records
        this.$refs.editChild.setCustomerData(customerList)
        if (!this.isSale()) {
          getAllFactory().then((res) => {
            var factoryList = res.data.data.records
            this.$refs.editChild.setFactoryData(factoryList)
            getOrderInfo(params.row.id).then((res) => {
              var data = res.data.data
              this.$refs.editChild.setEditData(data)

              searchSaleUser(data.factory_id).then((res) => {
                var userList = res.data.data.records
                this.$refs.editChild.setUserData(userList)
                this.editModal = true
              })
            })
          })
        } else {
          getOrderInfo(params.row.id).then((res) => {
            var data = res.data.data
            this.$refs.editChild.setEditData(data)

            getUserInfo().then((res) => {
              if (res.data.code == 200) {
                this.$refs.editChild.setSaleData(res.data.data)
                this.$refs.editChild.setIsSale(true)
                this.editModal = true
              }
            })
          })
        }
      })
      this.$refs.editChild.setIsEdit(true)
    },
    showEditUnitModal (params) {
      this.editUnitModal = true
      this.editUnitData = {
        id: params.row.id,
        price: params.row.one_code_money
      }
    },
    editUnitSubmit () {
      let data = new FormData()
      data.append('id', this.editUnitData.id)
      data.append('price', this.editUnitData.price)
      editUnitPrice(data, data.get('id'))
        .then((res) => {
          if (res.data.code == 200) {
            this.editUnitModal = false
            this.$Message.success('成功!')
            this.handleSearch()
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error('失败!')
        })
    },
    addSumit (formValidate) {
      addOrder(formValidate)
        .then((res) => {
          // res
          // data {code data msg}
          // status
          if (res.data.code == 200) {
            this.$Message.success('成功!')
            this.handleSearch()
            this.addModal = false
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error('失败!')
        })
    },
    editSumit (formValidate) {
      editOrder(formValidate)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success('成功!')
            this.editModal = false
            this.handleSearch()
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error('失败!')
        })
    },
    changeUserStatus (value, params) {
      let data = new FormData()
      data.append('id', params.row.id)
      data.append('status', value)
      updateUserStatus(data).then((res) => {
        if (res.data.code == 200) {
          this.$Message.success('成功!')
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    viewBatch (params) {
      this.$router.push({ name: 'batch', query: { id: params.row.id } })
    },
    cancelOrder (params) {
      cancelOrder(params.row.id).then((res) => {
        if (res.data.code == 200) {
          this.$Message.success('成功!')
          this.handleSearch()
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    cancel () {},
    changePage (page) {
      this.page = page
      this.handleSearch()
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleSearch () {
      this.setTableLoading(true)
      getOrderList(
        this.page,
        this.pageSize,
        this.searchValue,
        this.customerId,
        this.salesUserId,
        this.startTime,
        this.endTime,
        this.status
      ).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records
          this.total = res.data.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.setTableLoading(false)
      })
    },
    searchSales (factoryId) {
      searchSaleUser(factoryId).then((res) => {
        if (res.data.code == 200) {
          let sales = res.data.data.records
          if (this.addModal) {
            this.$refs.addChild.setUserData(sales)
          } else if (this.editModal) {
            this.$refs.editChild.setUserData(sales)
          }
        }
      })
    },
    getAllCustomer () {
      getAllCustomer()
        .then((res) => {
          if (res.data.code == 200) {
            this.customerIds = res.data.data.records
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error('失败!')
        })
    },
    getAllUser () {
      getAllUser()
        .then((res) => {
          if (res.data.code == 200) {
            this.salesUserIds = res.data.data.records
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error('失败!')
        })
    },
    handleDelete (params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          delOrder(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.tableData.splice(params.index, 1)
                this.$Message.success('成功!')
              } else if (res.data.code == 501) {
                this.$Message.error(res.data.msg)
              } else {
                this.$Message.error(res.data.msg)
              }
            })
            .catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
      // params
      // row
    },
    setTableLoading (state) {
      this.tableLoading = state
    }
  },
  mounted () {
    if (
      store.state.user.access.indexOf('sales') == -1 &&
      store.state.user.access.indexOf('Warehouse Manager') == -1
    ) {
      this.getAllUser()
    }
    this.handleSearch()
    if (store.state.user.access.indexOf('Warehouse Manager') == -1) {
      this.getAllCustomer()
    }
  }
}
</script>
